__turbopack_context__.v({
  "toggleGroup": "toggle-module-scss-module__36XeQG__toggleGroup",
  "toggleItem": "toggle-module-scss-module__36XeQG__toggleItem",
});
